import { render, staticRenderFns } from "./CookieSettingsButton.vue?vue&type=template&id=a6b8d59e"
import script from "./CookieSettingsButton.vue?vue&type=script&lang=js"
export * from "./CookieSettingsButton.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports